import classNames from 'classnames/bind';
import { useContext } from 'react';
import { InternationalContext } from 'contexts/international';
import { IModalComponent, Modal, ModalPosition } from 'contexts/modalFunc';
import SimilarList from './concurrent/similarList';
import styles from './index.module.scss';
import { SelectTypeKeys } from './types';

const cx = classNames.bind(styles);

const SimilarListContainer = ({
  modalInfo: { payload },
  setModal,
}: IModalComponent) => {
  if (!payload) return null;
  const { flightResult, promotions, samePriceOrgSch, selectFlights } = payload;
  const { sortSchs } = useContext(InternationalContext);
  const { schs } = flightResult;
  const sortedSchs = sortSchs(schs, SelectTypeKeys.concurrent, flightResult);
  const closeModal = () =>
    setModal({ type: Modal.NULL, position: ModalPosition.LIST });
  const handleClick = (
    sch: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => {
    closeModal();
    selectFlights(sch, fareType, airline, labels);
  };
  return (
    <div className={cx('SimilarListContainer')} aria-modal="true">
      <div className={cx('samePrice')}>
        <div className={cx('inner')}>
          <div className={cx('header')}>
            <div className={cx('inner')}>
              <h3 className={cx('title')}>동일가격 다른일정</h3>
              <button
                type="button"
                aria-label="닫기"
                className={cx('close')}
                onClick={() => closeModal()}
              />
            </div>
          </div>
          <SimilarList
            flightResult={flightResult}
            promotions={promotions}
            schs={sortedSchs.find(s => s.includes(samePriceOrgSch)) || []}
            selectFlights={handleClick}
          />
        </div>
      </div>
    </div>
  );
};

export default SimilarListContainer;
